import { differenceInWeeks, format, isToday } from 'date-fns';
import { frCA, enCA } from 'date-fns/locale';

export const formatMessageDate = (messageDate: string, locale?: 'en' | 'fr') => {
    const date = new Date(messageDate);
    const diffInWeeks = differenceInWeeks(new Date(), date);
    if (isToday(date)) {
        return format(date, 'p', { locale: locale === 'fr' ? frCA : enCA });
    }
    if (diffInWeeks < 1) {
        return format(date, 'MMM d', { locale: locale === 'fr' ? frCA : enCA });
    }

    return format(date, 'yyyy/MM/dd', { locale: locale === 'fr' ? frCA : enCA });
};

export const formatDateCustom = (date: string | number | Date): string => {
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, '0'); // getMonth() is zero-based
    const day = String(d.getDate()).padStart(2, '0');
    const year = d.getFullYear();
    const dateFormatted = `${month}/${day}/${year}`;
    
    if (dateFormatted === '12/31/1969') return null;

    return dateFormatted;
}

export const formatDateWithCustomFormat = (date: string | number | Date, format: string) : string => {
    if (!date && !format.trim().length) {
      return null;
    }

    const moment = require('moment');
    const momentDate = moment(date);
    return momentDate.format(format);
}

export const  isValidDate=(dateStr)=> {
  // Match MM/DD/YYYY (with leading zeros optional)
  const regex = /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12]\d|3[01])\/\d{4}$/;
  if (!regex.test(dateStr)) return false;

  // Parse numbers
  const [month, day, year] = dateStr.split("/").map(Number);

  // Construct a real Date object
  const date = new Date(year, month - 1, day);

  // Validate that the components match exactly
  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
}
